import { render, staticRenderFns } from "./SidebarMenuItem.vue?vue&type=template&id=6f8a3f5f&scoped=true&"
import script from "./SidebarMenuItem.vue?vue&type=script&lang=ts&"
export * from "./SidebarMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarMenuItem.vue?vue&type=style&index=0&id=6f8a3f5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8a3f5f",
  null
  
)

export default component.exports